import React from 'react'
import { 
  EditWMO,
  PackageWMO,
  TruckWMO
} from "@usap/uicomponents";
import { Heading, Section, TextWrapper, Label, ImageBox } from "../style/OwnShippingLabelWMO.css"

export default function OwnShippingLabelWMO({ addressDisplay }) {
  return (
    <>
      <Heading>
        Here&apos;s how to get your item(s) back to us:
      </Heading>
      <Section>
        <ImageBox>
          <EditWMO width="40" height="40" viewBox="0 0 40 40" />
        </ImageBox>
        <TextWrapper>
          <Label>1.</Label>
          <Label>
            Write your RMA ID on the Shipping Label you
            purchase from your respective carrier.
          </Label>
        </TextWrapper>
      </Section>
      <Section>
        <ImageBox style={{ height: '45px' }}>
          <PackageWMO width="44" height="45" viewBox="0 0 44 45" custom />
        </ImageBox>
        <TextWrapper>
          <Label>2.</Label>
          <Label>
            You can use any carrier of your choice
            to ship back the return. However, we highly recommend
            that you obtain a Tracking Number. The Tracking Number
            would serve as your proof of delivery if the package is misplaced.
          </Label>
        </TextWrapper>
      </Section>
      <Section>
        <ImageBox>
          <TruckWMO width="40" height="40" viewBox="0 0 40 40" custom />
        </ImageBox>
        <TextWrapper>
          <Label>3.</Label>
          <Label>
              Please send your return to this address: <br />
              <strong>{ addressDisplay }</strong>
          </Label>
        </TextWrapper>
      </Section>
    </>
  )
}
